// extracted by mini-css-extract-plugin
module.exports = {"headerCallCenter":"#129188","progressColor":"#d6e1df","goGoGreen":"#008a7b","green":"#5bc1a4","bankVault":"#747474"};